/* THE COUNTER — homepage card bands (sections/counter-home-bestsellers, counter-home-system).
   Card behaviour is the collection grid's (assets/counter-shelf.js), scoped to [data-ch-cards]:
   shade/size selection updates price and button; Add to bag holds 2.4s in Plum, refreshes and opens
   the drawer. Rail arrows page by whole cards; they hide when the row fits. */
(() => {
  if (window.__counterHome) return;
  window.__counterHome = true;
  const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const openDrawer = () => {
    const d = document.getElementById('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); return; } catch (e) {} }
    const opener = document.querySelector('[aria-controls="cart-drawer"]');
    if (opener) opener.click();
  };

  document.addEventListener('change', e => {
    const radio = e.target.closest('[data-ch-cards] .crc__radio');
    if (!radio) return;
    const card = radio.closest('[data-crc]');
    let vs = [];
    try { vs = JSON.parse(card.querySelector('[data-crc-variants]').textContent); } catch (err) {}
    const v = vs.find(x => x.id === +radio.value);
    if (!v) return;
    card.dataset.variant = v.id;
    const price = card.querySelector('[data-crc-price]');
    if (price) price.innerHTML = v.c ? `<s class="crc__was">${esc(v.c)}</s> <span class="crc__now">${esc(v.p)}</span>` : esc(v.p);
    const label = card.querySelector('[data-crc-label]');
    if (label && card.dataset.case === 'shade') label.textContent = v.o;
    const btn = card.querySelector('[data-crc-add]');
    if (btn) { btn.disabled = !v.a; btn.textContent = v.a ? 'Add to bag' : 'Sold out'; }
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-ch-cards] [data-crc-add]');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const card = btn.closest('[data-crc]');
    const id = +card.dataset.variant;
    if (!id) return;
    const label = btn.textContent;
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const r = await fetch(`${cartRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      if (!r.ok) throw new Error('add ' + r.status);
      btn.textContent = 'Added to bag';
      btn.style.background = '#A35F6E'; btn.style.borderColor = '#A35F6E'; btn.style.color = '#fff';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      openDrawer();
      setTimeout(() => { btn.textContent = label; btn.style.background = ''; btn.style.borderColor = ''; btn.style.color = ''; btn.disabled = false; btn.removeAttribute('aria-busy'); }, 2400);
    } catch (err) {
      btn.removeAttribute('aria-busy'); btn.disabled = false; btn.textContent = 'Try again';
    }
  });

  const wire = box => {
    if (box._chWired) return;
    const rail = box.querySelector('.crc-rail');
    const nav = box.querySelector('[data-ch-nav]');
    if (!rail || !nav) return;
    box._chWired = true;
    const [prev, next] = nav.querySelectorAll('button');
    const page = () => {
      const c = rail.querySelector('[data-crc]');
      if (!c) return rail.clientWidth;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const w = c.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((rail.clientWidth + gap) / w)) * w;
    };
    const upd = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -page(), behavior: reduce ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: page(), behavior: reduce ? 'auto' : 'smooth' }));
    let raf;
    rail.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  };
  const init = () => document.querySelectorAll('[data-ch-rail]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
